const Constants = require('utils/framework/Constants');
const combineReducers = require('redux').combineReducers;
const basket = require('./basket');
const category = require('./category');
const historyLocation = require('./framework/historyLocation');
const interstice = require('./interstice');
const modals = require('./modals');
const user = require('./user');
const loves = require('./loves');
const klarna = require('./klarna');
const afterpay = require('./afterpay');
const search = require('./search');
const productRecs = require('./productRecs');
const productSpecificDetails = require('./productSpecificDetails');
const inlineBasket = require('./inline-basket');
const testTarget = require('./testTarget');
const targeters = require('./targeters');
const welcomeMat = require('./welcomeMat');
const termsConditions = require('./termsConditions');
const targetedPromotion = require('./targetedPromotion');
const personalizedPromotions = require('./personalizedPromotions');
const availableRrcCoupons = require('./availableRrcCoupons');
const samples = require('./samples');
const rewards = require('./rewards');
const promo = require('./promo');
const applePaySession = require('./applePaySession');
const reduxActionWatch = require('redux-action-watch');
const intersticeRequests = require('./intersticeRequests');
const profile = require('./profile');
const socialInfo = require('./socialInfo');
const cookies = require('./cookies');
const catalog = require('./catalog');
const order = require('./order');
const editData = require('./editData');
const errors = require('./errors');
const beautyInsider = require('./beautyInsider');
const storeHub = require('./storeHub');
const wizard = require('./wizard');
const resetSessionExpiry = require('./resetSessionExpiry');
const creditCard = require('./creditCard');
const page = require('./page');
const ssrProps = require('./ssrProps');
const purchasedHistory = require('reducers/purchaseHistory');
const recentlyViewedData = require('reducers/recentlyViewedData');
const beautyRecommendations = require('reducers/beautyRecommendations');
const sponsorProducts = require('reducers/sponsorProducts');
const beautyPreferences = require('reducers/beautyPreferences');
const p13n = require('reducers/p13n');

//Higher Order function responsible for a generic reducer to merge two objects together
const withMerge = (reducerName, reducer) => (state, action) => {
    switch (action.type) {
        case `${reducerName}_MERGE`: {
            // eslint-disable-next-line object-curly-newline
            const { key, value } = action.payload;

            return {
                ...state,
                [key]: value
            };
        }
        default: {
            return reducer(state, action);
        }
    }
};

const reducers = {
    ssrProps,
    basket,
    inlineBasket,
    category,
    historyLocation,
    interstice,
    loves,
    klarna,
    afterpay,
    modals,
    catalog,
    user,
    search,
    productRecs,
    productSpecificDetails,
    targeters,
    testTarget,
    welcomeMat,
    termsConditions,
    targetedPromotion,
    personalizedPromotions,
    availableRrcCoupons,
    samples,
    rewards,
    applePaySession,
    promo,
    intersticeRequests,
    profile,
    socialInfo,
    cookies,
    order,
    editData,
    errors,
    beautyInsider,
    storeHub,
    wizard,
    resetSessionExpiry,
    creditCard,
    page,
    purchasedHistory,
    recentlyViewedData,
    beautyRecommendations,
    sponsorProducts,
    p13n,
    beautyPreferences
};

Object.keys(reducers).forEach(reducerName => {
    reducers[reducerName] = withMerge(reducerName, reducers[reducerName]);
});

reducers[Constants.ACTION_WATCHER_STATE_NAME] = reduxActionWatch.reducer;
const ufe = combineReducers(reducers);

module.exports = ufe;
